import type { SxProps, Theme } from "@mui/material";

/**
 * Layout do lado direito da barra do topo (atalhos + identidade).
 *
 * Abaixo de 1200px a Sidebar some e vira o botão-dropdown do
 * `Layout/MenuPopup` ("Dashboard ⌄"). Nessa faixa a barra não cabe em uma
 * linha só: os atalhos (notas, chat, suporte, sino) descem para uma SEGUNDA
 * linha, abaixo do bloco de identidade (papel + nome + foto).
 *
 * ⚠️ 1200px não é número solto: é o mesmo breakpoint do `MenuPopup`
 * (`@media (min-width: 1200px) { display: none }`). Mexeu lá, mexe aqui —
 * senão sobra uma faixa de larguras com o menuzinho E os atalhos na linha
 * de cima.
 *
 * Como funciona sem duplicar JSX: a ordem no DOM continua
 * `[atalhos][identidade]`, que é a ordem certa no desktop (`row`). No
 * empilhado usamos `column-reverse`, que sobe o ÚLTIMO filho (identidade)
 * e joga os atalhos para baixo.
 */
/**
 * Media query do estado empilhado, para uso com `useMediaQuery` no JSX
 * (ex.: escolher entre o logo horizontal e o quadradinho).
 */
export const NAV_STACK_MEDIA_QUERY = "(max-width: 1200px)";

/** A mesma coisa em forma de chave de objeto `sx`. */
export const NAV_STACK_BREAKPOINT = `@media ${NAV_STACK_MEDIA_QUERY}`;

/** Container dos dois grupos. */
export const navActionsSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  [NAV_STACK_BREAKPOINT]: {
    flexDirection: "column-reverse",
    alignItems: "flex-end",
  },
};

/** Linha dos atalhos (ícones de notas, chat, suporte e sino). */
export const navShortcutsSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

/** Bloco de identidade: RoleSwitcher (papel) + nome + foto. */
export const navIdentitySx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
};

/**
 * Margem que separa o sino do bloco de identidade na linha única. Empilhado
 * ela vira um deslocamento torto à direita, então zera.
 */
export const navBellSpacingSx = (isSmallScreen: boolean): SxProps<Theme> => ({
  lineHeight: "0",
  marginRight: isSmallScreen ? "12px" : "1.5rem",
  position: "relative",
  [NAV_STACK_BREAKPOINT]: { marginRight: 0 },
});
